import React from 'react';

import './Status.css';

function getTimeAgo(timestamp) {
  try {
    // Ensure the input is a string so .replace() doesn't throw an error
    if (typeof timestamp !== 'string') {
      return timestamp;
    }

    // 1. Clean the target timestamp (replace dashes with slashes)
    const cleanTimestamp = timestamp.replace(/-/g, '/');
    const pastTime = new Date(cleanTimestamp);
    
    // Check if the resulting date is valid
    if (isNaN(pastTime.getTime())) {
      return timestamp;
    }
    
    // 2. Get the exact current time in Pacific Time
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    
    const parts = formatter.formatToParts(new Date());
    const p = {};
    parts.forEach(({ type, value }) => { p[type] = value; });
    
    const hr = p.hour === '24' ? '00' : p.hour;
    const currentPtStr = `${p.year}/${p.month}/${p.day} ${hr}:${p.minute}:${p.second}`;
    
    // 3. Parse the current PT string and calculate difference
    const currentPtTime = new Date(currentPtStr);
    const diffMs = currentPtTime - pastTime;
    
    let totalMinutes = Math.ceil(diffMs / (1000 * 60));
    
    if (totalMinutes < 1) {
      totalMinutes = 1;
    }
    
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    const hrText = hours === 1 ? '1 hour' : `${hours} hours`;
    const minText = minutes === 1 ? '1 minute' : `${minutes} minutes`;
    
    if (hours === 0) {
      return `${minText} ago`;
    }
    
    return `${hrText}, ${minText} ago`;
    
  } catch (error) {
    // If any unexpected error occurs, return the raw input
    return timestamp;
  }
}

class Status extends React.Component {

	displayStatus(field) {
		// this function returns a class name for status-item
		// and status-value depending on whether api server is online or not

		if(field==='value') {
			if(this.props.serverOnline) {
				return('status-online')
			} else {
				return('status-offline')
			}
		} else if(field==='item') {
			if(this.props.serverOnline) {
				return('status-display')
			} else {
				return('status-hidden')
			}
		}  else if(field==='status') {
			if(this.props.serverOnline) {
				return('Online')
			} else {
				return('Offline')
			}
		}
	}

	render() {


		var lastUpload = getTimeAgo(this.props.serverLatest.upload);
		var lastSolve = getTimeAgo(this.props.serverLatest.solve);

		// var lastUpload = this.props.serverLatest.upload;
		// var lastSolve = this.props.serverLatest.solve;

		return (
			<div className="status-container">

				<div className='status-item'>
	        		<span className='status-label'>Server Status:  </span>
	        		<span className={`status-value ${this.displayStatus('value')}`}>{this.displayStatus('status')}</span>
	        	</div>
	        	<div className={`status-item ${this.displayStatus('item')}`}>
	        		<span className='status-label'>Latest Upload:  </span>
	        		<span className='status-value'>{lastUpload}</span>
	        	</div>
	        	<div className={`status-item ${this.displayStatus('item')}`}>
	        		<span className='status-label'>Latest Solve:  </span>
	        		<span className='status-value'>{lastSolve}</span>
	        	</div>

		    </div>
		)
	}
}



export default Status;